import React from 'react';
import { Form, Input } from 'antd';
const FormItem = Form.Item;
export let formReference = false;

const GetTokenForm = ({ form, onSubmitHandler }) => {
    const { getFieldDecorator } = form;
    formReference = form;
    return (
      <Form onSubmit={onSubmitHandler}>
          <p>Por favor informe o Token:</p>
        <FormItem>
            {
                getFieldDecorator('token', {
                    rules: [{required: true, message: 'Por favor informe o token antes de prosseguir!'}]
                })(
                    <Input/>
                )
            }
        </FormItem>
      </Form>
    );
};

const WrappedGetTokenForm = Form.create()(GetTokenForm);

export default WrappedGetTokenForm;




// WEBPACK FOOTER //
// ./src/components/GetTokenForm.js